// Purpose: Product color API calls
// Caller: productColorAction, ProductModal
// Dependencies: utils/xhr
// Main Functions: getProductColors, createProductColor, updateProductColor, deleteProductColor, getProductColorOptions
// Side Effects: HTTP CRUD /product-color, HTTP GET /product-color/options

import { xhr } from 'utils'

export const getProductColors = (params = '') => xhr.get(`/product-color?${params}`)
export const createProductColor = (data) => xhr.post('/product-color', data)
export const updateProductColor = (data, id) => xhr.put(`/product-color/${id}`, data)
export const deleteProductColor = (id) => xhr.delete(`/product-color/${id}`)
export const getProductColorOptions = () => xhr.get('/product-color/options')
